import { DateFormatPipe } from '@shared/pipes/date-format.pipe';
import { DateFromNowPipe } from '@shared/pipes/date-from-now.pipe';

export const CORE_PIPES = [DateFormatPipe, DateFromNowPipe];
